import { AnyNotificationContext } from "../components/Notifications";

export const selectorPayerNameFromContext = (
  context: AnyNotificationContext
): string => {
  if (context && "payer" in context && context.payer?.payerName) {
    return context.payer?.payerName;
  }

  // TODO: fix after remove all of that on BE
  // @ts-ignore
  return context?.client?.companyName || "your client";
};
